const primary = "#11A1FD";
/*rgba(17,161,253,1)*/
const secondary = "#FF1060";
const warning = "rgba(255,153,49,1)";
const success = "rgba(7,193,128,1)";
const info = "#9013FE";
const lightgrey = "#A9A9A9";
/*Body Background Color */
const primaryBackground = 'rgba(245,246,248,1)';
/*App Bar Height */
const appBarHeight = 60;
/*App Bar Background color */
const appBarBackgroundColor = primary;
const appBarMenuItemsColor = "rgba(255,255,255,1)";
/*Side Drawer Width */
const drawerWidth = 265;
/*Side Drawer Background Color */
const DrawerBackgroundColor = "rgba(255,255,255,1)";
const drawerMenuItemsColor = '#7D9EB5';
const fontFamily = 'Nunito Sans, sans-serif';

const capitalize = "capitalize";
const uppercase = "uppercase";
const textColor = "rgba(34,51,69,1)";
const statusSubHeading ="#486F88";
const menuItemsColor = '#7D9EB5';


const defaultMuiTheme = {
  palette: {
    primary: {

      main: primary,
      color:'white',

    },
    success:{
      main:success,
    },
    
    background: {
      //paper:primaryBackground,
      default: primaryBackground,
    },
  },
  appBar: {
    height: 100,
  },

  drawer: {
    width: drawerWidth,
    miniWidth: 56,

  },


  mixins: {
    toolbar: {
      minHeight: appBarHeight,
      background:appBarBackgroundColor,
     boxShadow: "0 10px 30px 0 rgba(82,63,105,0.08)",

    },


  },
  overrides: {
    
    MuiStep:{
      horizontal:{
        "&.mobileHorizontal":{
          paddingRight:0,
          paddingLeft:0,
          "& .MuiStepLabel-iconContainer":{
            paddingRight:0,
          }
        }

      },

    },
    MuiStepper:{
      root:{
        "&.mobileHorizontalPadding":{
          padding:'10px',
        },

      },
    },
    
  //     MuiListItem:{
  //       button:{
  //         '&:hover':{
  // backgroundColor:'none',
  // color:'none',
  // "& svg" :{
  //   //fill:'none'
  // }
  //         }
  //       },
  //     },
    
   
    MuiDialogActions:{
      root:{
        "& .MuiButtonBase-root":{
          fontWeight:'bold',
          '@media (min-width:0px) and (max-width:599.5px)': {
            fontSize: 13,
          },
          '@media (min-width:600px) and (max-width:959.5px)': {
            fontSize: 13,
          },
          '@media (min-width:960px) and (max-width:1279.5px)': {
            fontSize: 14,
          },
          '@media (min-width:1280px) and (max-width:1919.5px)': {
            fontSize: 15,
          },
          '@media (min-width:1920px) ': {
            fontSize: 20,
          },
        },
      },
    },
    MuiRadio:{
      root:{
     color:'#9db6c7'
      }
    },
    MuiStepLabel:{
      label:{
        fontWeight:'600 !important',
        "&.MuiStepLabel-alternativeLabel":{
          color:'#bcc1c3',
        },
        "&.MuiStepLabel-active":{
          color:'#000 !important',
          
        },
        "&.MuiStepLabel-completed":{
          color:'#000',
          
        } ,
        '@media (min-width:0px) and (max-width:599.5px)': {
          display:'none',
        },
      }
    },
MuiListItemIcon:{
      root:{
        minWidth:35,
      }
    },
    MuiPaper:{
      elevation1 :{
      boxShadow:" 0 0 6px rgba(82,63,105,0.1)",
  },
  
},
    MuiPickersDay:{
      daySelected:{
        color:'#fff'
      },
    },
    MuiPickersToolbarText:{
      toolbarTxt:{
        color:'#fff'
      },
      toolbarBtnSelected:{
        color:'#fff'
      }
    },
    MuiStepIcon:{
      root:{
        fontFamily: fontFamily,
        "&.MuiStepIcon-active":{
          
          "& .MuiStepIcon-text":{
            fill:"#fff",
          }
        },
        
      },
      
    },
    MuiInputLabel: {
      root: {
        textTransform: capitalize,
        fontFamily: "inherit",
        
        '@media (min-width:0px) and (max-width:599.5px)': {
          fontSize: 13,
        },
        '@media (min-width:600px) and (max-width:959.5px)': {
          fontSize: 13,
        },
        '@media (min-width:960px) and (max-width:1279.5px)': {
          fontSize: 14,
        },
        '@media (min-width:1280px) and (max-width:1919.5px)': {
          fontSize: 15,
        },
        '@media (min-width:1920px) ': {
          fontSize: 20,
        },
      },
    },
    
    MuiFormControlLabel: {
      label: {
        textTransform: capitalize,
        '@media (min-width:0px) and (max-width:599.5px)': {
          fontSize: 10,
        },
        '@media (min-width:600px) and (max-width:959.5px)': {
          fontSize: 13,
        },
        '@media (min-width:960px) and (max-width:1279.5px)': {
          fontSize: 14,
        },
        '@media (min-width:1280px) and (max-width:1919.5px)': {
          fontSize: 14,
        },
        '@media (min-width:1920px) ': {
          fontSize: 20,
        },
      }
    },
    
    MuiButton: { // Name of the component ⚛️ / style sheet
      root: { // Name of the rule
        textTransform: capitalize,
        fontFamily: fontFamily,
minWidth:'40px',
        color:"#000",
        '@media (min-width:0px) and (max-width:599.5px)': {
          fontSize: "8px "
        },
        '@media (min-width:600px) and (max-width:959.5px)': {
          fontSize: "8px "
        },
        '@media (min-width:960px) and (max-width:1279.5px)': {
          fontSize: "8px "
        },
        '@media (min-width:1280px) and (max-width:1919.5px)': {
          fontSize: "13px "
        },
        '@media (min-width:1920px) ': {
          fontSize: "18px "
        },
      },
    containedPrimary:{
      backgroundColor:"rgb(17,160,252)",
      color:"#fff",
      '&:hover': {
        backgroundColor: 'rgb(20,160,252)',
      },
    },
    },
    MuiTableCell: {
      root: {
        fontFamily: fontFamily,
        textTransform: capitalize,
      },
    },
    MuiMenuItem: {
      root: {
        fontFamily: fontFamily,
        textTransform: capitalize,
      },
    },
    MuiAppBar:{
      colorDefault: {
     
      backgroundColor: "#e7ecef",
  },
},
    MuiFormHelperText: {
      root: {
        fontFamily: fontFamily,
        textTransform: capitalize,
      },
    },
    MuiInputBase: {
      Input: {
        fontFamily: fontFamily,
        textTransform: capitalize,
        color: "#000",
        
      },

    },
    MuiInputBase: {
      root: {
        fontFamily: fontFamily,
        textTransform: capitalize,
        color: "#000",
        
        '@media (min-width:0px) and (max-width:599.5px)': {
          fontSize: "13px "
        },
        '@media (min-width:600px) and (max-width:959.5px)': {
          fontSize: "14px "
        },
        '@media (min-width:960px) and (max-width:1279.5px)': {
          fontSize: "15px "
        },
        '@media (min-width:1280px) and (max-width:1919.5px)': {
          fontSize: "16px "
        },
        '@media (min-width:1920px) ': {
          fontSize: "18px "
        },

      },
    },
    MuiOutlinedInput: {
      root:{
      '& fieldset': {
        //borderColor: 'red',
      },
      '&:hover fieldset': {
        // borderColor: 'yellow',
      },
      '&.Mui-focused': {
        // borderColor: 'green',
        // background:"red",
        //background:'#f3f7f9',
      },
      '&.Mui-disabled':{
background:'#f3f7f9',

      },
     }
    },
    
    
    MuiChip: {
      root: {
        fontFamily: fontFamily,
        textTransform: capitalize,
      },
    },
    MuiTab: {
      root: {
        fontFamily: fontFamily,
        textTransform: capitalize,

      },
    },
    MuiAutocomplete: {
      popper: {
        fontFamily: fontFamily,
        textTransform: capitalize,

      }
    },
    

    MuiAutocomplete: {
      option: {
        fontFamily: fontFamily,
        textTransform: capitalize,
        '@media (min-width:0px) and (max-width:599.5px)': {
          fontSize: 13,
        },
        '@media (min-width:600px) and (max-width:959.5px)': {
          fontSize: 14,
        },
        '@media (min-width:960px) and (max-width:1279.5px)': {
          fontSize: 15,
        },
        '@media (min-width:1280px) and (max-width:1919.5px)': {
          fontSize: 15,
        },
        '@media (min-width:1920px) ': {
          fontSize: 20,
        },

      }
    },
    MuiPaginationItem: {
      root: {
        fontFamily: fontFamily,
        '@media (min-width:0px) and (max-width:599.5px)': {
          fontSize: 10,
        },
        '@media (min-width:600px) and (max-width:959.5px)': {
          fontSize: 13,
        },
        '@media (min-width:960px) and (max-width:1279.5px)': {
          fontSize: 14,
        },
        '@media (min-width:1280px) and (max-width:1919.5px)': {
          fontSize: 14,
        },
        '@media (min-width:1920px) ': {
          fontSize: 20,
        },
      },
      textPrimary:{
        '&.Mui-selected':{
          
            color:'white',
         
        }}
    },
    MuiTypography: {
      fontFamily: fontFamily,
      textTransform: capitalize,
      h1: {
        fontFamily: fontFamily,
      },
      h2: {
        fontFamily: fontFamily,
      },
      h3: {
        fontFamily: fontFamily,
      },
      h4: {
        fontFamily: fontFamily,
      },
      h5: {
        fontFamily: fontFamily,
      },
      h6: {
        fontFamily: fontFamily,
      },
      h1: {
        fontFamily: fontFamily,
      },
      subtitle1: {
        fontFamily: fontFamily,
      },
      subtitle2: {
        fontFamily: fontFamily,
      },
      body1: {
        fontFamily: fontFamily,
        '@media (min-width:0px) and (max-width:599.5px)': {
          fontSize: 12,
        },
        '@media (min-width:600px) and (max-width:959.5px)': {
          fontSize: 13,
        },
        '@media (min-width:960px) and (max-width:1279.5px)': {
          fontSize: 15,
        },
        '@media (min-width:1280px) and (max-width:1919.5px)': {
          fontSize: 15,
        },
        '@media (min-width:1920px) ': {
          fontSize: 20,
        },
      },
      body2: {
        fontFamily: fontFamily,
        '@media (min-width:0px) and (max-width:599.5px)': {
          fontSize: 10,
        },
        '@media (min-width:600px) and (max-width:959.5px)': {
          fontSize: 13,
        },
        '@media (min-width:960px) and (max-width:1279.5px)': {
          fontSize: 15,
        },
        '@media (min-width:1280px) and (max-width:1919.5px)': {
          fontSize: 15,
        },
        '@media (min-width:1920px) ': {
          fontSize: 20,
        },
      },
      caption: {
        fontFamily: fontFamily,
      },
      overline: {
        fontFamily: fontFamily,
      },

    }
  },
};

export default {
  default: defaultMuiTheme,
  appBarHeight: appBarHeight,
  
  appBarMenuItemsColor :appBarMenuItemsColor ,

  drawerWidth: drawerWidth,

  DrawerBackgroundColor: DrawerBackgroundColor,
  drawerMenuItemsColor:drawerMenuItemsColor,
  primaryColor: primary,
  uppercase: uppercase,
  capitalize: capitalize,
  textColor: textColor,
  statusSubHeading:statusSubHeading,
  menuItemsColor:menuItemsColor,
};